import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';

import { parseErknmValue } from '../common/parseErknmValue';
import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';

interface IErknmControlProps {
  passportData?: IKnmPreview;
}

export const ErknmControl = ({ passportData }: IErknmControlProps) => {
  const kindControl = parseErknmValue<{
    number?: string;
    title?: string;
    shortTitle?: string | null;
    selectedLabel?: string;
  }>(passportData?.inspectionErknm?.kindControl?.value || '');
  const knoOrganization = passportData?.inspectionErknm?.knoOrganization?.value
    ? parseErknmValue<{
        fullName?: string | null;
      }>(passportData?.inspectionErknm?.knoOrganization?.value)
    : undefined;

  const kindControlLabel = () => {
    if (!kindControl) {
      return '';
    }

    if (passportData?.transferred && passportData?.transferringAuthorities) {
      const ervkTransferringTitles = passportData.transferringAuthorities
        .filter(x => x.title !== undefined && x.title !== null)
        .map(x => x.title);
      const ervkTransferringShortTitles = passportData.transferringAuthorities
        .filter(x => x.shortTitle !== undefined && x.shortTitle !== null)
        .map(x => x.shortTitle);

      if (ervkTransferringShortTitles.length) {
        return `${kindControl.number} - ${
          passportData?.inspectionErknm?.kindControl?.title || kindControl.title
        } - передано от ${ervkTransferringShortTitles.join(', ')}`;
      }
      if (ervkTransferringTitles.length) {
        return `${kindControl.number} - ${
          passportData?.inspectionErknm?.kindControl?.title || kindControl.title
        } - передано от ${ervkTransferringTitles.join(', ')}`;
      }
    }

    return `${kindControl.number} - ${passportData?.inspectionErknm?.kindControl?.title || kindControl.title}`;
  };

  const knoOrganizationLabel = () => {
    if (!knoOrganization) {
      return '';
    }

    return passportData?.inspectionErknm?.knoOrganization?.title || knoOrganization.fullName;
  };

  return (
    <div className={styles.ColumnContent}>
      <KnmSubtitle title="Контрольный (надзорный) орган">
        {passportData?.inspectionErknm?.knoOrganization && passportData?.inspectionErknm.knoOrganization.value && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Наименование органа контроля</div>
            <div className={styles.ColValue}>{knoOrganizationLabel()}</div>
          </div>
        )}
        {passportData?.inspectionErknm?.kindControl && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Вид контроля (надзора) и его номер</div>
            <div className={styles.ColValue}>{`${kindControlLabel()}`}</div>
          </div>
        )}
      </KnmSubtitle>
    </div>
  );
};
